import DashIcon from "assets/icons/DashIcon";
import { useState } from "react";
import {
  MdExpandLess,
  MdExpandMore,
  MdOutlineShoppingCart,
} from "react-icons/md";
import { Link, useLocation } from "react-router-dom";

export function SidebarLinks(props) {
  let location = useLocation();
  const { routes } = props;
  const [isOpen, setIsOpen] = useState(false); // State to handle dropdown

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen); // Toggle dropdown open/close
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.name === "Catalog") {
        // Handle dropdown for Catalog
        return (
          <div key={index}>
            <div
              onClick={toggleDropdown}
              className="flex cursor-pointer items-center justify-between px-8"
            >
              <li className={`my-[3px] flex items-center`}>
                <span
                  className={`${
                    activeRoute(route.path)
                      ? "font-bold text-primary dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? (
                    route.icon
                  ) : (
                    <MdOutlineShoppingCart className="h-6 w-6" />
                  )}
                </span>
                <p
                  className={`${
                    activeRoute(route.path)
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  } ml-4 flex`}
                >
                  {route.name}
                </p>
              </li>
              {isOpen ? (
                <MdExpandLess className="h-6 w-6" />
              ) : (
                <MdExpandMore className="h-6 w-6" />
              )}
            </div>
            {isOpen && (
              <ul className="pl-12">
                <li>
                  <Link to="/admin/catalog/product">Product</Link>
                </li>
                <li>
                  <Link to="/admin/catalog/categories">Categories</Link>
                </li>
              </ul>
            )}
          </div>
        );
      } else if (route.layout === "/admin" || route.layout === "/auth") {
        return (
          <Link key={index} to={route.layout + "/" + route.path}>
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li className="my-[3px] flex cursor-pointer items-center px-8">
                <span
                  className={`${
                    activeRoute(route.path)
                      ? "font-bold text-primary dark:text-white"
                      : "font-medium text-gray-600"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}
                </span>
                <p
                  className={`${
                    activeRoute(route.path)
                      ? "font-bold text-navy-700 dark:text-white"
                      : "font-medium text-gray-600"
                  } ml-4 flex`}
                >
                  {route.name}
                </p>
              </li>
              {activeRoute(route.path) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-primary dark:bg-primary" />
              ) : null}
            </div>
          </Link>
        );
      } else {
        return null;
      }
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
